<template>
  <div class="d-flex flex-column">
    <div class="grid-header">
      <h1>{{ $t("contactos_lead.titulo") }}</h1>
      <div class="toolbar">
      </div>
    </div>

    <DxDataGrid v-bind="getDefaultGridProperties()" :data-source="gridSource" ref="grid"
      class="dx-card wide-card grid-contactos-lead">
      <DxToolbar>
        <DxItem location="after" template="exportButtonTemplate" />
      </DxToolbar>
      <DxColumnFixing :enabled="true" />

      <DxColumn data-field="IdExterno" :caption="$t('contactos_lead.grid.id_externo')"></DxColumn>
      <DxColumn data-field="FechaRegistro" :caption="$t('contactos_lead.grid.fecha_registro')" data-type="datetime" 
        format="dd/MM/yyyy HH:mm:ss"></DxColumn>
      <DxColumn data-field="NombreCompleto" :caption="$t('contactos_lead.grid.nombre_completo')"></DxColumn>
      <DxColumn data-field="Telefono" :caption="$t('contactos_lead.grid.telefono')"></DxColumn>
      <DxColumn data-field="Ip" :caption="$t('contactos_lead.grid.ip')"></DxColumn>      
      <DxColumn type="buttons" :caption="$t('contactos_lead.grid.acciones')" :fixed="true" fixed-position="right" width="100px" :buttons="[
        {
          cssClass: 'btn btn-link text-decoration-none btn-sm',
          text: $t('contactos_lead.grid.descargar_documento_autorizacion'),
          icon: 'fa-regular fa-download text-success',
          onClick: (e: any) => descargarDocumentoAutorizacion(e.row?.data.RutaDocumentoAutorizacion),
          visible: (options: any) => options.row?.data.RutaDocumentoAutorizacion != null
        },
        {
          cssClass: 'btn btn-link text-decoration-none btn-sm',
          text: $t('contactos_lead.grid.generar_documento_autorizacion'),
          icon: 'fa-regular fa-file-pen text-success',
          onClick: (e: any) => generarDocumentoAutorizacion(e.row?.data.Id),
          visible: (options: any) => options.row?.data.RutaDocumentoAutorizacion == null
        }
      ]"/>

      <template #exportButtonTemplate>
        <button @click="onExporting" class="btn btn-sm btn-light d-flex align-items-center gap-2 m-2">
          <i class="fas fa-file-excel exportar-excel"></i>
          <span class="text-primary">{{ $t("shared.ui.buttons.exportToExcel") }}</span>
        </button>
      </template>
    </DxDataGrid>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { DxDataGrid, DxColumn, DxColumnFixing, DxToolbar, DxItem } from "devextreme-vue/data-grid";
import { exportGridToExcel, getDefaultGridProperties } from "@helpers/grid-helper";
import { useApi } from "@api/integration";
import type CustomStore from "devextreme/data/custom_store";
import { type DXLoadOptions } from "@/.shared/.api";
import FileSaver from "file-saver";
import { toastError, toastSuccess } from "@/.shared/services/notification-service";
import { useIntl } from "@/.shared/services/i18n";

const api = useApi();
const grid = ref<DxDataGrid>();
const gridSource = ref<CustomStore>();
const intl = useIntl();


onMounted(async () => {
  setDataSource();
});

const setDataSource = async () => {

  gridSource.value = api.apiStore({
    key: "Id",
    load: async (p) => {
      const q = p as DXLoadOptions;
      return await api.callStandardApi("getContactosLeadForGrid", { showLoading: false }, q)
    }
  });
}

const onExporting = async () => {
  await exportGridToExcel(
    grid.value!.instance,
    'ContactosLead.xlsx',
    'ContactosLead',
    true
  );
};

async function urlToBlob(ruta: string) {
  const response = await fetch(ruta);
  const data = await response.blob();
  const blob = new Blob([data], { type: "application/pdf;charset=utf-8" });
  return blob;
}

const descargarDocumentoAutorizacion = async (ruta: string) => {
  var tempUrl = await api.callStandardApi("documentosGenerateTempUrl", { showLoading: false }, ruta);
  urlToBlob(tempUrl).then((blob: any) => {
    try {
      var file = ruta.split('/').pop();
      FileSaver.saveAs(blob, file);
    }
    catch (error) {
      console.error('error', error);
    }
  });
}

const generarDocumentoAutorizacion = async (id: string) => {
  try {
    await api.callStandardApi("createAutorizacionCesionDatosContactoLead", { showLoading: true }, id);
    toastSuccess(intl.i18n.t('contactos_lead.grid.generar_documento_autorizacion_exito'));
    grid.value!.instance!.refresh();
  }
  catch (error) {
    toastError(intl.i18n.t('contactos_lead.grid.generar_documento_autorizacion_error'));
  }
}
</script>

<style lang="scss" scoped>
</style>